export const GetProjectsQueryResolver = {
    getProjects: () => ({
        count: 1,
        projects: [
            {
                id: 'df7d8bee-3966-4a14-af0f-821747d78fc0',
                budget: '$1-$5 Million',
                groupName: 'AE Project Group 1',
                groupId: '',
                imageUrl: null,
                isFavorite: true,
                lastUpdated: null,
                location: {
                    city: 'Los Angeles',
                    country: 'United States',
                    postalCode: '90048',
                    region: 'California',
                    street1: 'Medical Center South Tower, 8700 Beverly Blvd',
                    street2: null,
                },
                currentMilestone: {
                    phaseId: null,
                    phase: {
                        id: '',
                        name: 'Pre-Design',
                        loD: '',
                    },
                    endDate: '2020-08-21',
                    startDate: '2020-08-21',
                },
                name: 'TestAE Project 1',
                number: '11111',
                owner: 'test',
                parameters: [
                    {
                        modifierList: {
                            name: 'Building Type',
                        },
                        selectedModifiers: [
                            {
                                name: 'Warehouse',
                            },
                        ],
                    },
                    {
                        modifierList: {
                            name: 'Contract Type',
                        },
                        selectedModifiers: [
                            {
                                name: 'A101\u20132017, Stipulated Sum',
                            },
                        ],
                    },
                    {
                        modifierList: {
                            name: 'Construction Type',
                        },
                        selectedModifiers: [
                            {
                                name: 'Type V - Wood Framed/Combustive',
                            },
                        ],
                    },
                    {
                        modifierList: {
                            name: 'Sustainability Type',
                        },
                        selectedModifiers: [
                            {
                                name: 'LEED V4',
                            },
                        ],
                    },
                ],
                projectLeads: null,
                grossBuildingArea: 'test area',
            },
        ],
        facets: [
            {
                name: 'Budget',
                values: ['$1-$5 Million'],
            },
        ],
        projectGroupCounts: [
            {
                groupId: 'f6ae6cc0-574d-4fc4-816a-2ea2b858f367',
                totalCount: 219,
            },
        ],
    }),
}

export const RecentlyViewedProjectsQueryResolver = {
    getRecentlyViewedProjects: () => [
        {
            id: 'da65ecd9-cb26-4fb8-8664-dcc5caaa6e2d',
            budget: '$1-$5 Million',
            groupName: 'AE Project Group 1',
            imageUrl: null,
            isFavorite: true,
            location: {
                city: 'Los Angeles',
                country: 'United States',
                postalCode: '90048',
                region: 'California',
                street1: 'Medical Center South Tower, 8700 Beverly Blvd',
                street2: null,
            },
            currentMilestone: {
                id: 'milestone1',
                phase: {
                    name: 'Pre-Design',
                },
                endDate: '2020-08-21',
            },
            name: 'TestAE Project 2',
            number: '11111',
            owner: 'test',
            parameters: [
                {
                    modifierList: {
                        name: 'Building Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'Warehouse',
                        },
                    ],
                },
                {
                    modifierList: {
                        name: 'Contract Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'A101\u20132017, Stipulated Sum',
                        },
                    ],
                },
                {
                    modifierList: {
                        name: 'Construction Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'Type V - Wood Framed/Combustive',
                        },
                    ],
                },
                {
                    modifierList: {
                        name: 'Sustainability Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'LEED V4',
                        },
                    ],
                },
            ],
            grossBuildingArea: 'test area',
        },
        {
            id: 'df7d8bee-3966-4a14-af0f-821747d78fc0',
            budget: '$1-$5 Million',
            groupName: 'AE Project Group 1',
            imageUrl: null,
            isFavorite: true,
            location: {
                city: 'Los Angeles',
                country: 'United States',
                postalCode: '90048',
                region: 'California',
                street1: 'Medical Center South Tower, 8700 Beverly Blvd',
                street2: null,
            },
            currentMilestone: {
                id: 'milestone2',
                phase: {
                    name: 'Pre-Design',
                },
                endDate: '2020-08-21',
            },
            name: 'TestAE Project 1',
            number: '11111',
            owner: 'test',
            parameters: [
                {
                    modifierList: {
                        name: 'Building Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'Warehouse',
                        },
                    ],
                },
                {
                    modifierList: {
                        name: 'Contract Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'A101\u20132017, Stipulated Sum',
                        },
                    ],
                },
                {
                    modifierList: {
                        name: 'Construction Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'Type V - Wood Framed/Combustive',
                        },
                    ],
                },
                {
                    modifierList: {
                        name: 'Sustainability Type',
                    },
                    selectedModifiers: [
                        {
                            name: 'LEED V4',
                        },
                    ],
                },
            ],
            grossBuildingArea: 'test area',
        },
    ],
}

export const ProjectSearchResolver = {
    myProjectSearches: () => [
        {
            id: '86521607-918a-480f-ab80-30831205a8a1',
            name: 'super search',
        },
    ],
    projectSearchMatchFilterQuery: () => ({
        facets: [
            {
                name: 'Country',
                values: [
                    {
                        value: 'Argentina',
                        count: 3,
                    },
                ],
            },
        ],
    }),
    projectSearchMatchMapQuery: () => ({
        count: 6856,
        matches: [
            {
                constructionBudget: 'Not Listed',
                buildingType: 'Office',
                projectId: '36e4cd7b4b994ff89b2432ec72e8d2f6',
                leedLvl: 'None',
                createdDate: '2019-08-30',
                updatedDate: '2019-09-09',
                firmId: '1234',
                state: 'Washington',
                streetAddress1: '11332 NE 122nd Way',
                streetAddress2: null,
                zip: '98034',
                city: 'Kirkland',
                sectionSources: ['Custom Office Master'],
            },
        ],
        facets: [],
    }),
}

export const GetProjectQueryResolver = {
    getProject: () => ({
        id: 'df7d8bee-3966-4a14-af0f-821747d78fc0',
        firmId: 'dummyFirm',
        budget: '$1-$5 Million',
        groupName: 'AE Project Group 1',
        openBulkProcessId: '219ccd34-5f41-4df5-a116-5727d7b3ace4',
        owner: '',
        createdDate: '08/10/2020',
        location: {
            city: 'Los Angeles',
            country: 'United States',
            postalCode: '90048',
            region: 'California',
            street1: 'Medical Center South Tower, 8700 Beverly Blvd',
            street2: '',
        },
        milestones: [
            {
                phaseId: 'milestone2',
                phase: {
                    name: 'Pre-Design',
                    loD: 100,
                },
                endDate: '08/21/2020',
                startDate: '',
            },
        ],
        name: 'TestAE Project 1',
        number: '11111',
        projectTeam: {
            assignments: [
                {
                    description: 'Test User 1',
                    projectRole: 'Project Manager',
                    user: {
                        role: 'Reviewer',
                        siteId: 'b5adbaaa-4b52-4fa7-9c69-131a3558ec25',
                        status: 'Active',
                        profileInfo: {
                            firstName: 'escal',
                            imageUrl: null,
                            lastName: 'feta',
                            prefix: null,
                            professionalDiscipline: 'Structural',
                            professionalRole: 'Project Manager',
                            suffix: null,
                            title: null,
                        },
                    },
                },
                {
                    description: 'Test User 2',
                    projectRole: 'Project Manager',
                    user: {
                        role: 'Reviewer',
                        siteId: 'b5adbaaa-4b52-4fa7-9c69-131a3558ec25',
                        status: 'Active',
                        profileInfo: {
                            firstName: 'After',
                            imageUrl: null,
                            lastName: 'Last',
                            prefix: null,
                            professionalDiscipline: 'Architectural',
                            professionalRole: 'Project Manager',
                            suffix: null,
                            title: null,
                        },
                    },
                },
            ],
        },
        publishSettings: {
            exportAsPDF: false,
            exportAsDocx: true,
            cover: false,
            excludeSectionTitle: false,
            excludeTermSection: false,
            exportAsFullManual: true,
            exportAsIndividualFiles: false,
            fontColorsOn: true,
            hyperlinksActive: true,
            includeFolderForDivision: false,
            notesToSpecifier: false,
            prefixWithSectionFileNamesWithSection: true,
            revisionHistory: false,
            bookmarks: false,
            widowOrphanControl: false,
        },
    }),
}

export const GetProjectTeamQueryResolver = {
    getProject: () => ({
        id: 'df7d8bee-3966-4a14-af0f-821747d78fc0',
        projectTeam: {
            assignments: [
                {
                    description: 'Test User 1',
                    projectRole: 'Project Manager',
                    user: {
                        role: 'Reviewer',
                        siteId: 'b5adbaaa-4b52-4fa7-9c69-131a3558ec25',
                        status: 'Active',
                        id: 'user1',
                        profileInfo: {
                            firstName: 'escal',
                            imageUrl: null,
                            lastName: 'feta',
                            prefix: null,
                            professionalDiscipline: 'Structural',
                            professionalRole: 'Project Manager',
                            suffix: null,
                            title: null,
                        },
                    },
                },
                {
                    description: 'Test User 2',
                    projectRole: 'Project Manager',
                    user: {
                        role: 'Reviewer',
                        siteId: 'b5adbaaa-4b52-4fa7-9c69-131a3558ec25',
                        status: 'Active',
                        id: 'user2',
                        profileInfo: {
                            firstName: 'After',
                            imageUrl: null,
                            lastName: 'Last',
                            prefix: null,
                            professionalDiscipline: 'Architectural',
                            professionalRole: 'Project Manager',
                            suffix: null,
                            title: null,
                        },
                    },
                },
            ],
        },
    }),
}
